module.exports = __webpack_public_path__ + "static/media/ninth_newpaper_plant2.7548104e.jpeg";